import * as Sentry from '@sentry/browser';

import { trackMixpanelEvent } from './mixpanel-init';

export const addLogsToSentry = (userObj, logEntry) => {
  Sentry.withScope(scope => {
    if (userObj) {
      scope.setUser(userObj);
    }
    if (typeof logEntry === 'object') {
      Sentry.captureException(new Error(JSON.stringify(logEntry)));
    } else if (logEntry instanceof Error) {
      Sentry.captureException(logEntry);
    } else {
      Sentry.captureMessage(logEntry);
    }
  });
};

export const addLogsInSentryAndMixpanel = (userObj, title) => {
  trackMixpanelEvent(title, userObj);
  addLogsToSentry(userObj, title);
};
